const actions = [
    {
        type: 'ADD_FORM',
        form: []
    },
    {
        type: 'REMOVE_FORM',
        id: 1
    },
    {
        type: 'UPDATE_FORM',
        form: []
    },
    {
        type: 'REMOVE_ALL_FORM'
    }
];

export default actions;



/** WEBPACK FOOTER **
 ** ./src/actions/formActions.js
 **/